import React from "react";
import WhatwedoBglanding from "./WhatwedoBglanding";
import WhatwedoHeading from "./WhatwedoHeading";
import { Box, Typography } from "@mui/material";
import WhatwedoContent from "./WhatwedoContent";
import { Helmet } from "react-helmet";

const Whatwedo4 = () => {
  return (
    <>
      <Helmet>
        <title>Inteliphyle | Effective Visualization</title>
        <meta
          name="description"
          content="From intuitive performance dashboards to cutting-edge visualization tools, we unlock your data's potential and present it to you in a highly simplified manner."
        />
      </Helmet>
      <Box
        sx={{
          backgroundColor: "#ecebeb",
        }}
      >
        <WhatwedoBglanding />
        <WhatwedoHeading />
        <WhatwedoContent />
        {/* <Typography
        sx={{
          textAlign: "left",
          color: "rgba(51, 51, 51, 1)",
          fontFamily: "Plus Jakarta Sans",
          padding: { xs: "1rem", sm: "1rem 0 1rem 4rem" },
        }}
      >
        Partner with us to harness the full potential of visualization and
        dashboarding capabilities and transform your data into actionable
        insights that drive business success.
      </Typography> */}
      </Box>
    </>
  );
};

export default Whatwedo4;
